<!-- @format -->

<paid-summary-detail-tag>

	<style>
		.head_memo{
			font-size:2rem;
			padding-bottom: 0.5rem;
		}
	</style>


	<div class="container_breadcrumb">
		<ul class="breadcrumb">
			<li class="breadcrumb-item"><span class="heading-01 heading_orders">受注履歴・請求関連</span></li>
			<li class="breadcrumb-item"><a href="/project/paid-summary">支払調書</a></li>
			<li class="breadcrumb-item">詳細</li>
		</ul>
	</div><!--/.container_breadcrumb-->

	<div class="contents">
		<section class="contents_area">

			<p class="head_memo">
				<span style="font-weight:bold;font-size: 2.2rem">{state.summary_detail.description.target_year}年</span>に
				「<span style="font-weight:bold;font-size: 2.2rem">{state.summary_detail.description.client_name}</span>」様から受注したプロジェクトの集計情報を表示しています
			</p>
			<div class="contents_block detail">
				<detail-description description="{state.summary_detail.description}"></detail-description>
			</div>

			<br>

			<div class="contents_block detail">
				<detail-summary-items items={state.summary_detail.items} company_type={state.summary_detail.description.company_type} ></detail-summary-items>
			</div>

		</section>

	</div>


	<script>
		import di from "dependency-injection";
		import detailDescription from "@tags/pages/project/paid-summary/detail-description.riot"
		import detailSummaryItems from "@tags/pages/project/paid-summary/detail-summary-items.riot"

		export default {
			components: {
				"detail-description": detailDescription,
				"detail-summary-items": detailSummaryItems,
			},
			api: false,
			state: {
				summary_detail : {
					description : {},
					items : [],
				},
			},
			onBeforeMount(props, state){
				//URLから引数を取得
				let target_year = props.routeParams[0];
				let client_id = props.routeParams[1];

				this.api = di.createApi('project');
				this.getDetail(target_year,client_id);
			},
			async getDetail(target_year,client_id){

				const res = await this.api.request(
						"paid-summary",
						"fetch-summary-detail",
						{
							target_year: target_year,
							client_id: client_id
						}
				);
				this.update({ summary_detail: res });
			},
		}
	</script>
</paid-summary-detail-tag>
